import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Welcome from "@/pages/Welcome";
import ProductDetail from "@/pages/ProductDetail";
import LadyStarzz from "@/pages/LadyStarzz";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";

function App() {
  return (
    <div className="App bg-[#0b0b0b] text-white min-h-screen">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/lady-starzz" element={<LadyStarzz />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
